import { render, staticRenderFns } from "./tranBarChart.vue?vue&type=template&id=3888ba7a&scoped=true"
import script from "./tranBarChart.vue?vue&type=script&lang=js"
export * from "./tranBarChart.vue?vue&type=script&lang=js"
import style0 from "./tranBarChart.vue?vue&type=style&index=0&id=3888ba7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888ba7a",
  null
  
)

export default component.exports